export default "__VITE_ASSET__41ef2342__"